import { Link } from "react-router-dom";
import { Container } from "../../components/layout/Container";
import { Card } from "../../components/ui/Card";
import { usePageTitle } from "../../lib/usePageTitle";
import styles from "../Prose.module.css";


export function TermsPage() {
  usePageTitle(
    "Условия использования — Geobiom",
    "Условия использования Geobiom: что можно делать с сайтом, какие гарантии и ограничения.",
  );
  return (
    <Container as="article" size="narrow">
      <h1 className={styles.h1}>Условия использования</h1>

      <Card>
        <p className={styles.p} style={{ margin: 0, color: "var(--ink-dim)" }}>
          Драфт от 25 апреля 2026 года. Это не юридически согласованное
          соглашение, а честное описание того, как устроен сайт и что
          от пользователя ожидается. По мере роста проекта документ
          будет дорабатываться.
        </p>
      </Card>

      <h2 className={styles.h2}>1. Что за сайт</h2>
      <p className={styles.p}>
        Грибная карта — бесплатный некоммерческий сервис, отображающий
        лесохозяйственные и природные данные Ленинградской области на
        интерактивной карте. Сайт не оказывает платных услуг, не
        продаёт рекламу и не гарантирует постоянной доступности.
      </p>

      <h2 className={styles.h2}>2. Безопасность сбора — читайте прежде всего</h2>
      <Card>
        <p className={styles.p} style={{ margin: 0 }}>
          <strong>
            Сайт не определяет грибы и не даёт рекомендаций по съедобности.
          </strong>{" "}
          Полигоны на карте показывают лес и его породный состав; список
          видов в попапе — это справочная информация о том, какие грибы{" "}
          <em>теоретически</em> ассоциированы с данным типом леса, а не
          о том, что в данной точке что-то точно есть и безопасно к
          употреблению. Идентификация собранного гриба, проверка на
          съедобность и отсутствие двойников — полностью ответственность
          того, кто гриб собрал.
        </p>
      </Card>
      <ul style={{ paddingLeft: "1.25rem", lineHeight: "var(--lh-long)", marginBottom: "var(--space-4)" }}>
        <li>
          Не ешьте грибы, которые не смогли уверенно определить до вида.
          Многие смертельно ядовитые виды (бледная поганка, галерина,
          паутинник) визуально похожи на съедобные. Автоматическое
          определение по фото в мобильных приложениях ошибается
          регулярно; один серьёзный промах может убить.
        </li>
        <li>
          Если сомневаетесь — не пробуйте. Лучше выбросить ведро
          грибов, чем одну ядовитую шляпку съесть.
        </li>
        <li>
          При любых признаках отравления грибами (тошнота, рвота,
          мышечная слабость, особенно через 6+ часов после еды) —
          немедленно в скорую помощь, и возьмите остатки грибов с собой:
          токсиколог сможет подобрать антидот.
        </li>
      </ul>

      <h2 className={styles.h2}>3. Законность сбора</h2>
      <p className={styles.p}>
        Карта показывает особо охраняемые природные территории (ООПТ)
        и защитные леса. Сбор в них может быть ограничен или запрещён
        — режим конкретного участка регулируется Лесным кодексом РФ и
        региональными положениями. Ответственность за соблюдение норм
        сбора полностью на пользователе.
      </p>

      <h2 className={styles.h2}>4. Аккаунт</h2>
      <p className={styles.p}>
        Для доступа к личному кабинету нужен вход через Яндекс ID.
        Создавая аккаунт, вы соглашаетесь с настоящими условиями и{" "}
        <Link to="/legal/privacy">политикой конфиденциальности</Link>.
        Вы отвечаете за сохранность доступа к своей почте — через неё
        можно получить доступ к аккаунту.
      </p>
      <p className={styles.p}>
        Мы оставляем за собой право заблокировать аккаунт без
        предупреждения в случае явных нарушений (флуд, спам,
        автоматизированные атаки, попытки эксплуатации API). Удаление
        аккаунта по собственному желанию — через{" "}
        <a href="mailto:ikocherov@mail.ru">ikocherov@mail.ru</a>{" "}
        (см. политику конфиденциальности, раздел 5).
      </p>

      <h2 className={styles.h2}>5. Пользовательский контент</h2>
      <p className={styles.p}>
        Места, заметки и поездки, которые вы сохраняете в кабинете,
        видны только вам и находятся в вашей собственности. Мы не
        индексируем и не передаём их третьим лицам. Возможность
        делиться местами публично может появиться позже — это будет
        явный opt-in, не по умолчанию.
      </p>

      <h2 className={styles.h2}>6. Открытые данные и API</h2>
      <p className={styles.p}>
        Эндпоинты <code>/api/*</code> и PMTiles-файлы открыты без
        аутентификации — предполагается, что кто-то захочет построить
        на их основе своё. Ограничений на rate нет, но при злоупотреблении
        (сотни запросов в секунду) можем ввести. Атрибуция данных:
        Рослесхоз / ФГИС ЛК, OpenStreetMap contributors, Copernicus
        DEM GLO-30, Docuchaev Soil Institute. Подробнее —{" "}
        <Link to="/methodology">методология</Link>.
      </p>

      <h2 className={styles.h2}>7. Гарантии — нет</h2>
      <p className={styles.p}>
        Сайт и данные предоставляются «как есть» (as-is), без каких-либо
        гарантий — ни явных, ни подразумеваемых. Мы не гарантируем
        актуальность, точность или пригодность данных для каких-либо
        целей. В частности, данные Рослесхоза частично устаревшие
        (некоторые выделы не обновлялись с 2015 года). Проверять важные
        для вас сведения лучше в первоисточниках.
      </p>
      <p className={styles.p}>
        В максимальных пределах, разрешённых применимым правом, автор
        не несёт ответственности за любые убытки, потери или травмы,
        связанные с использованием сайта, включая (но не ограничиваясь)
        последствия сбора, определения или употребления грибов.
      </p>

      <h2 className={styles.h2}>8. Изменения условий</h2>
      <p className={styles.p}>
        Условия могут меняться. Дата последнего обновления — в шапке.
        Существенные изменения отражаются в коммитах{" "}
        <a
          href="https://github.com/yungkocherov/mushroom_map/commits/main"
          target="_blank"
          rel="noreferrer"
        >
          репозитория
        </a>
        . Продолжая пользоваться сайтом после изменений, вы принимаете
        новые условия.
      </p>

      <h2 className={styles.h2}>9. Применимое право</h2>
      <p className={styles.p}>
        К настоящим условиям применяется законодательство Российской
        Федерации. Все споры по возможности решаются перепиской; при
        необходимости — в суде по месту жительства автора.
      </p>

      <p className={styles.p} style={{ color: "var(--ink-dim)", fontSize: "var(--fs-sm)" }}>
        См. также:{" "}
        <Link to="/legal/privacy">политика конфиденциальности</Link>,{" "}
        <Link to="/about">о проекте</Link>.
      </p>
    </Container>
  );
}
